"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

import { createDefaultDataBindings } from "../Category/getCategoryContentBindings";

import { CATEGORY_ITEMS_INPUTS } from "./CategoryItems.inputs.builder";

type CategoryItemsBindings = {
  items: "categoryItems";
  subcategoriesMap: "subcategoriesMap";
};

export const CategoryItemsComponent: RegisteredComponent = {
  name: "Category items",
  component: dynamic(async () => (await import("./CategoryItems")).CategoryItems),
  models: [getBuilderModelName("category")],
  defaults: {
    bindings: createDefaultDataBindings<CategoryItemsBindings>({
      items: "categoryItems",
      subcategoriesMap: "subcategoriesMap",
    }),
  },
  inputs: CATEGORY_ITEMS_INPUTS,
};
